let chartConsumo = {
  chartConsumo: {
    tip: 'Ponta',
    off_the_tip: 'Fora de ponta'
  }
};

export default chartConsumo;
